export default {
  EVENTS: 'companies/:company_id/events/'
}
